import React from 'react';
import PropTypes from 'prop-types';

const DishesCutleryNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeWidth={0.8}
      d="M6.496 8.963h.4V5.125c0-.021.02-.103.09-.184.064-.072.133-.103.197-.103s.134.03.197.103c.07.08.09.163.09.184v4.537c0 1.023-.798 1.827-1.71 1.941l-.35.044v9.978c0 .322-.106.559-.262.714-.155.156-.392.261-.713.261-.321 0-.558-.105-.713-.26-.155-.156-.26-.393-.26-.715v-9.978l-.351-.044c-.912-.114-1.711-.918-1.711-1.94V5.124c0-.021.02-.103.09-.184.064-.072.133-.103.197-.103.115 0 .18.036.215.071.035.035.072.1.072.216v3.838h2.174V5.125c0-.021.02-.103.09-.184.064-.072.133-.103.197-.103.115 0 .18.036.215.071.035.035.072.1.072.216v3.838h1.774Zm5.21 4.412v-.4h-1.374v-7.85c0-1.981 1.407-3.517 3.322-3.705v20.205c0 .322-.106.559-.261.714-.155.156-.392.261-.713.261-.322 0-.558-.105-.714-.26-.155-.156-.26-.393-.26-.715v-8.25Zm4.807-5.054.002-.017v-.017c0-1.159.354-2.207.916-2.956.561-.75 1.31-1.181 2.119-1.181.808 0 1.558.432 2.119 1.18.562.75.916 1.798.916 2.957v.017l.002.017c.123 1.487-.617 2.87-1.892 3.764l-.171.12v9.42c0 .322-.105.559-.26.714-.156.156-.393.261-.714.261-.321 0-.558-.105-.713-.26-.156-.156-.261-.393-.261-.715v-9.421l-.17-.12c-1.276-.893-2.016-2.276-1.893-3.763Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

DishesCutleryNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default DishesCutleryNot;
